import { useMemo } from 'react';
import { Trans } from '@lingui/macro';
import { Center, LoadingOverlay, Stack, TextInput } from '@mantine/core';
import { useDebouncedState } from '@mantine/hooks';
import { observer } from 'mobx-react-lite';

import { getNameLocal } from '../../../lib/local/get-title';
import { useLocal } from '../../../lib/local/use-local';
import { OptionsList } from './options-list';

type NameLangs = {
  nameRu: string | null;
  nameEn: string | null;
  nameHy: string | null;
};

type SelectSearchListProps = {
  data: { value: string; label: NameLangs }[];
  placeholder?: string;
  loading?: boolean;
  onSelect?: (item: { value: string; label: NameLangs } | null) => void;
};

export const SelectSearchList = observer(
  ({ placeholder, data, loading = false, onSelect }: SelectSearchListProps) => {
    const [lang] = useLocal();
    const [value, setValue] = useDebouncedState('', 200);

    const isStationListEmpty = data.length === 0;

    const filteredData = useMemo(() => {
      const result = data.filter(({ label }) =>
        getNameLocal(lang, label).includes(value.trim())
      );

      return result;
    }, [data, lang, value]);

    return (
      <Stack>
        <LoadingOverlay visible={loading} />

        <TextInput
          placeholder={placeholder}
          size="lg"
          onChange={(event) => setValue(event.currentTarget.value)}
        />

        {!loading && isStationListEmpty && (
          <Center mt={32}>
            <Trans>Станции отсутствуют</Trans>
          </Center>
        )}

        {!loading && !isStationListEmpty && (
          <OptionsList data={filteredData} onSelect={onSelect} />
        )}
      </Stack>
    );
  }
);
